import React from "react";

const TextStyles = ({ color, children, style }) => {
  // Set up a base style object
  let textStyle = {
    ...style, // Always apply any custom styles passed through `style` prop
  };

  // Apply conditional styles based on the `color` prop
  if (color === "gradient") {
    textStyle = {
      ...textStyle,
      background: "#06513D",
      color: "",
      WebkitTextFillColor: "transparent",
      WebkitBackgroundClip: "text",
      // fontWeight: "normal",
    };
  } else if (color === "blue") {
    textStyle = {
      ...textStyle,
      color: "#1E40AF",
    };
  }

  return (
    <div>
      <p style={textStyle}>{children}</p>
    </div>
  );
};

export default TextStyles;
